import React from 'react';
import styles from './statBox.module.scss'; // Ensure the CSS is properly linked

const StatBox = ({ value, percentageChange, title}) => {
    const percentageClass = percentageChange < 0 ? styles.arrow_down : styles.arrow_up;

  return (
    <div className={styles.total_sales}>
      <div className={styles.sales_title}>{title}</div>
      <div className={styles.sales_amount}>{value != null ? '$' + value.toLocaleString() : "Select date range".toLocaleString()}</div>
      <div className={styles.sales_comparison}>
        <span className={percentageClass}>
          {percentageChange == null ? '' : percentageChange < 0 ? '↓' : '↑'}
          {percentageChange != null ? Math.abs(percentageChange).toString() + '%': ''}</span> {percentageChange != null ? 'vs last 7 days' : ''}
      </div>
    </div>
  );
};

export default StatBox;